import React from 'react';
import { useEditorToolbar } from '@atlaskit/editor-common/toolbar';
import { ToolbarSection } from '@atlaskit/editor-toolbar';
export var OverflowSection = function OverflowSection(_ref) {
  var children = _ref.children,
    hasSeparator = _ref.hasSeparator,
    testId = _ref.testId;
  var _useEditorToolbar = useEditorToolbar(),
    editorAppearance = _useEditorToolbar.editorAppearance;
  if (editorAppearance === 'full-page') {
    return null;
  }
  return /*#__PURE__*/React.createElement(ToolbarSection, {
    hasSeparator: hasSeparator,
    testId: testId
  }, children);
};